module.exports = __webpack_public_path__ + "static/media/1.cd70c042.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/lhand/1.png
// module id = 1332
// module chunks = 0